'use client';

import { IcArrowDown } from '@musinsa/mds';
import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

export interface SnapTaggedGoodsRowSheetTriggerProps extends ComponentPropsWithoutRef<'div'> {
  'aria-label': string;
}

export const SnapTaggedGoodsRowSheetTrigger = forwardRef<
  HTMLDivElement,
  SnapTaggedGoodsRowSheetTriggerProps
>(({ className, ...rest }, ref) => (
  <div
    ref={ref}
    className={clsx(
      'sticky top-0 right-0 z-10 flex shrink-0 cursor-pointer items-stretch self-stretch ml-auto',
      className,
    )}
    {...rest}
  >
    <div className="w-[12px] shrink-0 self-stretch bg-[linear-gradient(90deg,rgba(255,255,255,0)_0%,#fff_100%)] [transform:translateZ(0)]" />
    <div className="flex shrink-0 self-stretch items-center bg-neutral-color-white pl-1 pr-4">
      <div className="flex size-6 shrink-0 items-center justify-center rounded-full border border-solid border-gray-400 bg-neutral-color-white">
        <IcArrowDown height="12px" strokeColor="black" width="12px" />
      </div>
    </div>
  </div>
));

SnapTaggedGoodsRowSheetTrigger.displayName = 'SnapTaggedGoodsRowSheetTrigger';
